import { GDFRvrRecord } from '../../../gdf/type';

export default function RvrTooltip({ record }: { record: GDFRvrRecord }) {
    return (
        <div>
            <div>Station: {record.airportId}</div>
            {record.elements.slice(0, 20).map((x, i) => (
                <div key={i} className="pt-2">
                    <div>
                        <span>Runway: {x.runway} </span>
                        <span>Lights </span>
                        <span>Center: {stringify(x.lightsCenter, 0, 5, 'N/R')} </span>
                        <span>Edge: {stringify(x.lightsEdge, 0, 5, 'N/R')} </span>
                    </div>
                    <div>
                        <span>Visibility </span>
                        <span>Touchdown: {visibilityToString(x.touchDownVisibility)} </span>
                        <span>Midpoint: {visibilityToString(x.midpointVisibility)} </span>
                        <span>Rollout: {visibilityToString(x.rollOutVisibility)} </span>
                    </div>
                </div>
            ))}
        </div>
    );
}

function stringify(input: number, min: number, max: number, nullString: string, multiplier: number = 1): string {
    return input >= min && input <= max ? (input * multiplier).toString() : nullString;
}

function visibilityToString(input: number): string {
    if (input >= 0 && input <= 60) {
        return (input * 100).toLocaleString('en-US') + ' ft';
    }

    if (input === 65) {
        return '> 6,000 ft';
    }

    return 'N/R';
}
